import React from 'react';
import CreateReactClass from 'create-react-class';
import bibtexParse from 'bibtex-parse-js';
var BibPhdThesis = CreateReactClass({
  render: function render() {
    var tags = this.props.entry.entryTags;
    return React.createElement('div', null, React.createElement('span', null, tags.author), '. ', React.createElement('span', {
      style: {
        fontWeight: 'bold'
      }
    }, tags.title), '. Ph.D Thesis (', tags.year, ')');
  }
});
var BibArticle = CreateReactClass({
  render: function render() {
    var tags = this.props.entry.entryTags;
    return React.createElement('div', null, React.createElement('span', null, tags.author), '. ', React.createElement('span', {
      style: {
        fontWeight: 'bold'
      }
    }, tags.title), ' in ', React.createElement('span', {
      style: {
        fontStyle: 'italic'
      }
    }, tags.journal, ' ', tags.volume, '(', tags.volume, '):', tags.pages), ', ', React.createElement('span', null, tags.year));
  }
});
var BibInProceedings = CreateReactClass({
  render: function render() {
    var tags = this.props.entry.entryTags;
    return React.createElement('div', null, React.createElement('span', null, tags.author), '. ', React.createElement('span', {
      style: {
        fontWeight: 'bold'
      }
    }, tags.title), ' in ', React.createElement('span', {
      style: {
        fontStyle: 'italic'
      }
    }, tags.booktitle), '. Pages ', React.createElement('span', null, tags.pages), '. ', React.createElement('span', null, tags.address), ' ', React.createElement('span', null, tags.year));
  }
});
export default CreateReactClass({
  getInitialState: function getInitialState() {
    return {
      elements: this.buildElements(this.props.bibtex)
    };
  },
  buildElements: function buildElements(bibtex) {
    var bibJSON = bibtexParse.toJSON(bibtex);
    var elements = [];

    for (var i = 0; i < bibJSON.length; i++) {
      var et = bibJSON[i].entryType.toLowerCase();

      if (et == "inproceedings" || et == "conference") {
        elements.push(React.createElement('li', {
          key: i
        }, React.createElement(BibInProceedings, {
          entry: bibJSON[i]
        })));
      } else if (et == "article") {
        elements.push(React.createElement('li', {
          key: i
        }, React.createElement(BibArticle, {
          entry: bibJSON[i]
        })));
      } else if (et == "phdthesis") {
        elements.push(React.createElement('li', {
          key: i
        }, React.createElement(BibPhdThesis, {
          entry: bibJSON[i]
        })));
      } else if (et == "book") {} else if (et == "booklet") {} else if (et == "inbook") {} else if (et == "incollection") {} else if (et == "manual") {} else if (et == "mastersthesis") {} else if (et == "misc") {} else if (et == "proceedings") {} else if (et == "techreports") {} else if (et == "unpublished") {}
    }

    return elements;
  },
  render: function render() {
    return React.createElement('ol', null, this.state.elements);
  }
});